export default __webpack_public_path__ + "static/media/flag-eng.7adf1269.svg";